import React, { useCallback } from 'react';
import { Clickable, Popover } from '@moda/om';
import { useUser } from '../../hooks/useUser';
import { AccountLinks } from '../AccountLinks';
import { Link } from '../Link';
import { useAuthModal } from '../../hooks/useAuthModal';

import './SitePromoBannerLink.scss';

const SitePromoBannerLinkSignedOut: React.FC = () => {
  const { openAuthModal } = useAuthModal();

  const handleClick = useCallback(() => {
    openAuthModal();
  }, [openAuthModal]);

  return (
    <Clickable className="SitePromoBannerLink" onClick={handleClick}>
      Sign In
    </Clickable>
  );
};

const SitePromoBannerLinkSignedIn: React.FC<{ firstName: string }> = ({ firstName }) => {
  return (
    <Popover className="SitePromoBannerLink__popover" content={<AccountLinks />} anchor="topRight">
      <Link className="SitePromoBannerLink" to="/account">
        Hi, {firstName}
      </Link>
    </Popover>
  );
};

export const SitePromoBannerLink: React.FC = () => {
  const { user } = useUser();

  return user.isLoggedIn && user.firstName ? (
    <SitePromoBannerLinkSignedIn firstName={user.firstName} />
  ) : (
    <SitePromoBannerLinkSignedOut />
  );
};
